export const logo = {
  black: require('./2Front-logo-black.png'),
  white: require('./2Front-logo-white.png')
};
